import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  ButtonGroup,
  Autocomplete,
  LinearProgress,
} from "@mui/material";
import Swal from "sweetalert2";
import {
  CommonSubHeader,
  useLocationHelpers,
} from "../../Components/helpers/Helpers";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../../api/axios";
import { buscarDuplicados } from "../../Components/helpers/ContactPlusClient/ContactNClientsHelpers";

const Crear = ({
  setSelectedDataNewCase = () => {},
  transferState = false,
  dataClientTransfered = false,
}) => {
  const navigate = useNavigate();

  const { goPanel, goTable } = useLocationHelpers();

  const [options, setOptions] = useState({
    // offices: [],
    inssUsers: [],
    client_id: [],
    user_id: [],
    case_type: [],
    case_contract: [],
    companies: [],
  });

  const [searchParams] = useSearchParams();
  const clientId = searchParams.get("id");
  // const [loadingOptionsOffices, setLoadingOptionsOffices] = useState(false);
  // const [loadingOptionsINSS, setLoadingOptionsINSS] = useState(false);
  const [loadingOptionsClients, setLoadingOptionsClients] = useState(false);
  const [loadingOptionsLawyers, setLoadingOptionsLawyers] = useState(false);
  const [loadingOptionsCaseType, setLoadingOptionsCaseType] = useState(false);
  const [loadingOptionsContracts, setLoadingOptionsContracts] = useState(false);

  const [contactData, setContactData] = useState([]);

  var debounceTimeout = useRef(null);

  const [dataCase, setDataCase] = useState({
    // idfisico: "",
    // offices: null,
    user_id: null,
    // inssUsers: null,
    client_id: null,
    case_type: null,
    case_contract: null,
    company_id: null,
  });

  const [titularNoClientNoUserToSend, setTitularNoClientNoUserToSend] =
    useState(0);
  const [titularNoClientNoUserToShow, setTitularNoClientNoUserToShow] =
    useState(false);
  const [flag, setFlag] = useState(false);

  // Fetch data for the form
  const getData = async () => {
    setFlag(true);
    try {
      let url;
      let parametros = {};

      if (!clientId) {
        url = `${process.env.REACT_APP_API_URL}/cases/create`;
      } else {
        url = `${process.env.REACT_APP_API_URL}/cases/create`;
        parametros = { client_id: Number(clientId) };
      }

      if (dataClientTransfered?.id) {
        url = `${process.env.REACT_APP_API_URL}/cases/create`;
        parametros = { client_id: Number(dataClientTransfered?.id) };
      }

      const response = await api.post(url, parametros || null);

      const {
        // officesList,
        lawyersListFullData,
        clientsListNames,
        // authInssList,
        casesTypeList,
        contractList,
        companiesList,
      } = response.data;

      console.log(clientsListNames);

      let clientData;

      if (clientId) {
        clientData = response?.data?.clientsListNames[0];

        // Buscar cliente para obtener case por medio de contacto que esta ligado al documento (nif)
        const baseUrlContact = `${process.env.REACT_APP_API_URL}/contacts/search`;

        const queryParamsContact = {
          document: clientData?.nif,
        };

        const { data } = await api.post(baseUrlContact, queryParamsContact);
        const { contacts } = data;

        console.log(contacts);
        if (contacts) {
          const caseTypeFromContact = casesTypeList.find(
            (ct) => ct.id === contacts[0]?.case_type,
          );

          setDataCase((prev) => ({
            ...prev,
            case_type: caseTypeFromContact || null,
          }));
        }
        // End buscar cliente

        setDataCase((prevData) => ({
          ...prevData,
          ["user_id"]:
            clientData?.lawyers_relation && clientData?.lawyers_relation.id != 0
              ? clientData?.lawyers_relation
              : null,
          ["client_id"]: clientData && clientData?.id != 0 ? clientData : null,
          ["company_id"]:
            clientData && clientData?.company_id != 0
              ? clientData?.company_relation
              : null,
        }));
      }

      setOptions({
        user_id: [
          { name: "Seleccionar", surname: "", id: 0 },
          ...lawyersListFullData,
        ],
        client_id: [
          { name: "Seleccionar", surname: "", id: 0 },
          ...clientsListNames,
        ],
        case_type: [{ case_type: "Seleccionar", id: 0 }, ...casesTypeList],
        case_contract: [
          { contract_title: "Seleccionar", id: 0 },
          ...contractList,
        ],
        companies: [{ company_name: "Seleccionar", id: 0 }, ...companiesList],
      });
    } catch (error) {
      console.log(error);
    } finally {
      setFlag(false);
    }
  };

  const filteredClients = useMemo(() => {
    if (!dataCase.company_id || dataCase.company_id.id === 0) {
      return options.client_id;
    }

    return options.client_id.filter(
      (c) => c.id === 0 || c.company_relation?.id === dataCase.company_id.id,
    );
  }, [dataCase.company_id, options.client_id]);

  const filteredCaseTypes = useMemo(() => {
    if (!dataCase.company_id || dataCase.company_id.id === 0) {
      return options.case_type;
    }

    return options.case_type.filter(
      (t) => t.company_id === dataCase.company_id.id || t.id === 0,
    );
  }, [dataCase.company_id, options.case_type]);

  const filteredLawyers = useMemo(() => {
    if (!dataCase.company_id || dataCase.company_id.id === 0) {
      return options.user_id;
    }

    return options.user_id.filter(
      (u) => u.company_id === dataCase.company_id.id || u.id === 0,
    );
  }, [dataCase.company_id, options.user_id]);

  useEffect(() => {
    if (!dataCase.company_id || clientId) return;

    setDataCase((prev) => ({
      ...prev,
      client_id: null,
      user_id: null,
      case_type: null,
    }));
  }, [dataCase.company_id]);

  useEffect(() => {
    getData();
  }, [transferState]);

  useEffect(() => {
    if (transferState && dataCase?.client_id) {
      setSelectedDataNewCase(dataCase);
    }
  }, [dataCase, transferState]);

  // Form submit handler
  const handleCasesFormInformation = async () => {
    console.log(dataCase);

    // Definir campos obligatorios y su validación
    const requiredFields = {
      contracts: !dataCase?.case_contract,
      case_types: !dataCase?.case_type,
      client: !dataCase?.client_id,
      lawyer: !dataCase?.user_id,
    };

    const allFieldsValid = !Object.values(requiredFields).includes(true);

    if (allFieldsValid) {
      const formData = new FormData();
      Object.entries(dataCase).forEach(([key, value]) => {
        formData.append(key, value?.id); // Appends the id if it exists
      });

      const queryUrl = `${process.env.REACT_APP_API_URL}/cases/store`;

      Swal.fire({
        title: "¿Desea guardar los cambios?",
        icon: "warning",
        showDenyButton: true,
        confirmButtonColor: "#1ab394",
        cancelButtonColor: "#d33",
        reverseButtons: true,
        confirmButtonText: "Guardar",
        denyButtonText: `Volver`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          // 🟡 **Mostrar Swal de carga**
          Swal.fire({
            title: "Guardando...",
            text: "Por favor espere",
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });

          try {
            const response = await api.post(queryUrl, formData);
            console.log(response);

            Swal.close(); // Cerrar loading

            if (response.data.error) {
              Swal.fire({
                title: "¡No se guardaron los cambios!",
                icon: "error",
                text: "Por favor inténtelo nuevamente",
                confirmButtonColor: "#1ab394",
              });
            } else {
              Swal.fire({
                title: "¡Guardado!",
                icon: "success",
                confirmButtonColor: "#1ab394",
                confirmButtonText: "Ver Expediente",
                allowOutsideClick: false,
                allowEscapeKey: false,
                showCancelButton: false,
                showConfirmButton: false,
                timer: 2000,
              }).then((result) => {
                navigate(
                  "/expedientes/ver?id=" + response.data.case_created.id,
                );
              });
            }
          } catch (error) {
            Swal.close(); // Cerrar loading si hay error
            console.error(error);

            Swal.fire({
              title: "Error",
              icon: "error",
              text: "No se pudo guardar el caso. Inténtelo nuevamente.",
              confirmButtonColor: "#1ab394",
            });
          }
        } else if (result.isDenied) {
          Swal.fire("¡Los cambios no han sido guardados!", "", "info");
        }
      });
    } else {
      // Mostrar mensaje de error con los campos faltantes
      const fieldMessages = {
        contracts: "Contrato.",
        case_types: "Tipo de caso.",
        client: "Cliente.",
        lawyer: "Abogado.",
      };

      const missingFields = Object.keys(requiredFields)
        .filter((field) => requiredFields[field])
        .map((field) => `<li>${fieldMessages[field]}</li>`)
        .join("");

      Swal.fire({
        title: '<strong style="color: #f27474">¡Error!</strong>',
        icon: "error",
        confirmButtonColor: "#1ab394",
        html: `Por favor complete los siguientes campos:<ul>${missingFields}</ul>`,
      });
    }
  };

  const handleChange = (event) => {
    setDataCase({
      ...dataCase,
      [event.target.name]: event.target.value.trim(),
    });
  };

  const handleAutocompleteChange = (event, value, fieldName) => {
    console.log(value, fieldName);
    setDataCase((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };

  const handleChangeCheckbox = (event) => {
    if (titularNoClientNoUserToShow == true) {
      setTitularNoClientNoUserToSend(!titularNoClientNoUserToSend);
      setTitularNoClientNoUserToShow(!titularNoClientNoUserToSend);
    } else {
      setTitularNoClientNoUserToSend(!titularNoClientNoUserToSend);
      setTitularNoClientNoUserToShow(!titularNoClientNoUserToShow);
    }
  };

  // Fields for the form
  const formFields = useMemo(() => {
    // {
    //   name: "idfisico",
    //   label: "Expediente Fisico",
    //   key: "idfisico",
    //   type: "text",
    // },
    // {
    //   name: "offices",
    //   label: "Despacho",
    //   key: "offices",
    //   type: "autocomplete",
    //   options: options.offices,
    //   loading: loadingOptionsOffices,
    //   isOptionEqualToValue: (option, value) =>
    //     option.office_name === value.office_name,
    //   getOptionLabel: (option) => option.office_name || "",
    //   transform: (value) => value.office_name, // función para transformación
    // },

    // {
    //   name: "inssUsers",
    //   label: "Autorizados INSS, Banco.. (Abogados Autorizados)",
    //   key: "inssUsers",
    //   type: "autocomplete",
    //   options: options.groups,
    //   loading: loadingOptionsOffices,
    //   isOptionEqualToValue: (option, value) => option.grupo === value.grupo,
    //   getOptionLabel: (option) => option.grupo || "",
    //   transform: (value) => value.grupo, // función para transformación
    // },
    var fieldsCommonConfig = [
      {
        name: "company_id",
        label: "Empresa",
        key: "company_id",
        type: "autocomplete",
        options: options.companies || [],
        loading: false,
        disabled: clientId ? true : false,
        isOptionEqualToValue: (option, value) => option?.id === value?.id,
        getOptionLabel: (option) => option.company_name || "",
      },
      {
        name: "case_type",
        label: "Tipo de proceso",
        key: "case_type",
        type: "autocomplete",
        options: filteredCaseTypes,
        loading: loadingOptionsCaseType,
        disabled: !dataCase?.company_id && !clientId,
        isOptionEqualToValue: (option, value) => option?.id === value?.id,
        getOptionLabel: (option) => option.case_type || "",
      },

      {
        label: "Hoja de Encargo/Contrato",
        name: "case_contract",
        key: "case_contract",
        type: "autocomplete",
        options: options.case_contract || null,
        loading: loadingOptionsContracts,
        disabled: !dataCase?.company_id && !clientId,
        isOptionEqualToValue: (option, value) => option?.id === value?.id,
        getOptionLabel: (option) => option.contract_title || "",
        transform: (value) => value.contract_title, // función para transformación
      },
    ];
    if (!transferState) {
      fieldsCommonConfig.splice(1, 0, {
        name: "user_id",
        label: "Abogado",
        key: "user_id",
        type: "autocomplete",
        options: filteredLawyers || null,
        loading: loadingOptionsLawyers,
        disabled: !dataCase?.company_id && !clientId,
        isOptionEqualToValue: (option, value) =>
          option.name + " " + option.surname ===
          value.name + " " + value.surname,
        getOptionLabel: (option) => option.name + " " + option.surname || "",
        transform: (value) => value.name + " " + value.surname, // función para transformación
      });
      fieldsCommonConfig.splice(2, 0, {
        name: "client_id",
        label: "Cliente",
        key: "client_id",
        type: "autocomplete",
        options: filteredClients, // 👈 FILTRADO
        loading: loadingOptionsClients,
        disabled: !dataCase?.company_id && !clientId,
        isOptionEqualToValue: (option, value) =>
          `${option?.name} ${option?.surname}` ===
          `${value?.name} ${value?.surname}`,
        getOptionLabel: (option) =>
          option ? `${option.name || ""} ${option.surname || ""}` : "",
      });
    }

    return fieldsCommonConfig;
  }, [
    options,
    transferState,
    filteredClients,
    filteredLawyers,
    filteredCaseTypes,
    loadingOptionsClients,
    loadingOptionsLawyers,
    loadingOptionsCaseType,
    loadingOptionsContracts,
  ]);

  return (
    <div className="fatherContainer">
      {!transferState && (
        <CommonSubHeader title="Expedientes" subTitle="Crear" />
      )}
      {flag && <LinearProgress color="success" />}
      {!flag && (
        <Box
          component="form"
          sx={{ margin: "auto", "& > :not(style)": {} }}
          noValidate
          autoComplete="off"
          className="formMainContainer">
          <Grid
            container
            style={{ textAlign: "center" }}
            p={2}
            className="fontSize">
            {formFields.map((field, idx) =>
              field.type === "autocomplete" ? (
                <Grid item xs={12} sm={6} key={idx} sx={{ padding: "5px" }}>
                  <Autocomplete
                    size="small"
                    value={dataCase[field.name] || null}
                    disabled={field.disabled}
                    onChange={(event, value) =>
                      handleAutocompleteChange(event, value, field.name)
                    }
                    // onInputChange={(event, inputValue) => {
                    //   clearTimeout(debounceTimeout); // Limpia el timeout anterior si existe
                    //   debounceTimeout = setTimeout(() => {
                    //     searchClient(inputValue);
                    //   }, 700);
                    // }}
                    options={field.options}
                    loading={field.loading}
                    isOptionEqualToValue={field.isOptionEqualToValue}
                    getOptionLabel={field.getOptionLabel}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={field.label}
                        autoComplete="new-password" // Desactiva el autofill general
                        fullWidth
                      />
                    )}
                  />
                </Grid>
              ) : (
                <Grid item xs={12} sm={6} key={idx} sx={{ padding: "5px" }}>
                  <TextField
                    size="small"
                    name={field.name}
                    label={field.label}
                    value={dataCase[field.name]}
                    onChange={handleChange}
                    autoComplete="new-password" // Desactiva el autofill general
                    fullWidth
                    inputProps={{
                      maxLength:
                        field.name === "associationPostalCode" ? 10 : undefined,
                    }}
                  />
                </Grid>
              ),
            )}
            {/* TITULAR  */}
            {/* <Grid
                container
                p={"5px"}
                m={"5px"}
                sx={{
                  // boxShadow: "0px 1px 4px 0px gray",
                  marginTop: "15px",
                }}
              >
                <Checkbox
                  checked={
                    titularNoClientNoUserToShow == false ||
                    titularNoClientNoUserToSend == 0
                      ? false
                      : true
                  }
                  onClick={handleChangeCheckbox}
                  inputProps={{ "aria-label": "controlled" }}
                  color="success"
                  sx={{
                    "& .MuiSvgIcon-root": {
                      fontSize: 28,
                      width: 28,
                      height: 28,
                    },
                  }}
                />
                <Grid item xs={10} md={11} m={"auto"}>
                  <div
                    style={{
                      fontWeight: "700",
                      textAlign: "left",
                      color: "#676a6c",
                    }}
                  >
                    EL TITULAR del expediente NO es el mismo que
                    CLIENTE/USUARIO.
                  </div>
                </Grid>
              </Grid> */}
            {!transferState && (
              <Grid item xs={12}>
                <ButtonGroup
                  sx={{
                    width: "100%",
                    justifyContent: "center",
                    textAlign: "center",
                    margin: "20px 5px 0px 5px",
                  }}>
                  <Button
                    sx={{ width: "100%" }}
                    onClick={handleCasesFormInformation}
                    variant="outlined"
                    color="success">
                    Guardar
                  </Button>
                  <Button
                    sx={{ width: "100%" }}
                    onClick={() => goTable("expedientes", "Expedientes")}
                    variant="outlined"
                    color="error">
                    Tabla
                  </Button>
                  <Button
                    sx={{ width: "100%" }}
                    onClick={goPanel}
                    variant="outlined">
                    Panel
                  </Button>
                </ButtonGroup>
              </Grid>
            )}
          </Grid>
        </Box>
      )}
    </div>
  );
};

export default Crear;
